import {
  useCurrentRefinements,
  useHits,
  useInstantSearch,
} from "react-instantsearch";

import type { Project } from "@tudigo-monorepo/core-tudigo-api-models";

import { ProjectsCardGrid } from "../../../shared-external/components/projects-card-grid";
import { SearchProjectsPagination } from "../../shared-internal/components/search-projects/search-projects-pagination";
import { useSortFinishedProjectsByEndDate } from "../hooks/use-sort-finished-projects-by-end-date";
import { DefaultFinishedProjectsLayout } from "./default-finished-projects-layout";
import { EmptySearchResults } from "./empty-search-results";

export function FinishedProjectsContent() {
  const { hits } = useHits();
  const { canRefine: hasRefinements } = useCurrentRefinements();
  const { results } = useInstantSearch();
  const { query, nbHits } = results;

  useSortFinishedProjectsByEndDate();

  if (query.length > 0 && nbHits === 0) {
    return (
      <div className="container mx-auto px-4 py-6 md:py-10">
        <EmptySearchResults />
      </div>
    );
  }

  if (hasRefinements || (query.length > 0 && nbHits > 0)) {
    return (
      <div className="container mx-auto px-4 py-6 md:py-10">
        <ProjectsCardGrid projects={hits as any as Project[]} />
        <SearchProjectsPagination
          onPageChange={() => {
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
        />
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-6 md:py-10">
      <DefaultFinishedProjectsLayout />
    </div>
  );
}
